// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"177":"ec85c881","532":"0619589a","851":"3e3b3b36","981":"64880273"}[chunkId] + ".chunk.css";
};